import React, { useMemo, useState } from 'react';
import { PackageIcon } from 'lucide-react';
import { PageHeader } from '../components/layout/PageHeader';
import { FAB } from '../components/ui/FAB';
import { EmptyState } from '../components/ui/EmptyState';
import { BorrowedItemCard } from '../components/borrowed/BorrowedItemCard';
import { AddBorrowedItemSheet } from '../components/borrowed/AddBorrowedItemSheet';
import { useAppData } from '../contexts/AppDataContext';
export function BorrowedItems() {
  const {
    borrowedItems,
    addBorrowedItem,
    markBorrowedReturned,
    deleteBorrowedItem
  } = useAppData();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const {
    pending,
    returned
  } = useMemo(() => {
    const sorted = [...borrowedItems].sort((a, b) => new Date(a.dateBorrowed).getTime() - new Date(b.dateBorrowed).getTime());
    return {
      pending: sorted.filter(item => !item.returned),
      returned: sorted.filter(item => item.returned)
    };
  }, [borrowedItems]);
  return <div className="relative flex h-full flex-col" data-id="element-157" data-mp="709r6yh67qma">
      <PageHeader title="Borrowed items" subtitle={pending.length ? `${pending.length} not yet returned` : 'Everything is returned'} data-id="element-158" data-mp="6zgs8joge5ep" />
      <div className="flex-1 space-y-3 overflow-y-auto px-5 py-4 pb-28" data-id="element-159" data-mp="gptbm8kj7sj9">
        {borrowedItems.length === 0 ? <EmptyState icon={PackageIcon} title="Nothing tracked yet" description="Add an item you've lent out to keep tabs on it." data-id="element-160" data-mp="lomn5vg9d9gs" /> : <>
            {pending.map(item => <BorrowedItemCard key={item.id} item={item} onMarkReturned={() => markBorrowedReturned(item.id)} onDelete={() => deleteBorrowedItem(item.id)} data-id="element-161" data-mp="3p53913dh89kp" />)}
            {returned.length > 0 && <div className="pt-2" data-id="element-162" data-mp="19eqt49gx5lay">
                <p className="mb-2 px-1 text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-163" data-mp="19dp574et14bt">Returned</p>
                <div className="space-y-3" data-id="element-164" data-mp="1dehge378ljaq">
                  {returned.map(item => <BorrowedItemCard key={item.id} item={item} onMarkReturned={() => markBorrowedReturned(item.id)} onDelete={() => deleteBorrowedItem(item.id)} data-id="element-165" data-mp="3afdh0g0v0oc3" />)}
                </div>
              </div>}
          </>}
      </div>
      <FAB label="Add borrowed item" onClick={() => setIsAddOpen(true)} colorClassName="bg-amber-600 hover:bg-amber-700" data-id="element-166" data-mp="2qrxs2wz2gppz" />
      <AddBorrowedItemSheet isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} onSubmit={addBorrowedItem} data-id="element-167" data-mp="2msf8c4izekoq" />
    </div>;
}